/**
 * @fileoverview The i18next namespace marketing-shell's own strings register under.
 * @package @puffin-core/marketing-shell
 *
 * A ZERO-IMPORT leaf module, deliberately: `useMarketingShellTranslate()` is imported by the shell's
 * components, and routing the constant through `strings/index.js` would drag `en.js` and `es.js`
 * into every one of those import chains for one short string.
 *
 * LIFE-SHORTLISTED-001 F-Q7-1 (2026-09-28) — the ONE source of the shell's words, replacing
 * `BASE_MARKETING_BUNDLES` (which nothing imported) and the nine copies each marketing site carried.
 *
 * @module @puffin-core/marketing-shell/strings/namespace
 */

/** The canonical namespace under which marketing-shell strings live in i18next. */
export const MARKETING_SHELL_NAMESPACE = 'marketingShell';
